<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Rekapitulasi Nilai Ujian" @back="back">
            <a-descriptions bordered>
                <a-descriptions-item label="Sesi Kelas">
                    {{ itemsSession.name }}
                </a-descriptions-item>
                <a-descriptions-item label="Waktu kelas dimulai">
                    <template v-if="itemsSession.session_time_start != null">
                        {{ moment(itemsSession.session_time_start).format('DD-MM-YYYY HH:mm:ss') }}
                    </template>
                </a-descriptions-item>
                <a-descriptions-item label="Waktu kelas berakhir">
                    <template v-if="itemsSession.session_time_end != null">
                        {{ moment(itemsSession.session_time_end).format('DD-MM-YYYY HH:mm:ss') }}
                    </template>
                </a-descriptions-item>
            </a-descriptions>
        </a-page-header>

        <a-row style="margin-bottom: 20px;">
            <a-col class="text-right">
                <download-excel :data="excel" :name="`exam-report ${itemsSession.name}.xls`">
                    <a-button :loading="loading" type="primary">Download <a-icon type="cloud-download" /> </a-button>
                </download-excel>
            </a-col>
        </a-row>

        <a-card type="inner" size="small">
            <a-table class="pcp-table" :dataSource="items.users_scores" rowKey="hash" :loading="loading" :pagination="false" bordered>

                <a-table-column key="photo" title="Foto" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <div style="text-align: center">
                            <img :src="record.photo" v-if="record.photo != null" width="70px" />
                            <a-avatar class="avatar" size="large" shape="circle" v-else>{{ initial(record.name) }}</a-avatar>
                        </div>
                    </template>
                </a-table-column>

                <a-table-column key="name" title="Nama" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <strong>{{ record.name }}</strong>
                    </template>
                </a-table-column>

                <a-table-column key="gender" title="Gender" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <strong>{{ gender(record.gender) }}</strong>
                    </template>
                </a-table-column>

                <a-table-column-group class="column-score">
                    <span slot="title">Pre Test</span>

                    <a-table-column key="pretest_questions" title="Soal (Q/A/C)" className="align-center text-small text-center">
                        <div slot-scope="record">
                            <h3 title="Question / Answered / Correct">
                                {{ extractAttempt(record, 99).total_questions  }} / {{ extractAttempt(record, 99).total_answered }} / {{ extractAttempt(record, 99).total_correct_answer }}
                            </h3>
                        </div>>
                    </a-table-column>

                    <a-table-column key="pretest_score" title="Score" className="align-center text-small text-center">
                        <span slot-scope="record">
                            <template v-if="extractAttempt(record, 99).raw_score < 65">
                                <strong><a-badge status="error" :text="extractAttempt(record, 99).raw_score" /></strong>
                            </template>
                            <template v-else>
                                <strong><a-badge status="success" :text="extractAttempt(record, 99).raw_score" /></strong>
                            </template>
                        </span>
                    </a-table-column>
                </a-table-column-group>

                <a-table-column-group class="column-score">
                    <span slot="title">Ujian</span>

                    <a-table-column key="exam_questions" title="Soal" className="align-center text-small text-center">
                        <div slot-scope="record">
                            <h3 title="Question / Answered / Correct">
                                {{ extractAttempt(record, 1).total_questions  }} / {{ extractAttempt(record, 1).total_answered }} / {{ extractAttempt(record, 1).total_correct_answer }}
                            </h3>
                        </div>
                    </a-table-column>

                    <a-table-column key="pretest_score" title="Score (Q/A/C)" className="align-center text-small text-center">
                        <span slot-scope="record">
                            <template v-if="extractAttempt(record, 1).raw_score < 65">
                                <strong><a-badge status="error" :text="extractAttempt(record, 1).raw_score" /></strong>
                            </template>
                            <template v-else>
                                <strong><a-badge status="success" :text="extractAttempt(record, 1).raw_score" /></strong>
                            </template>
                        </span>
                    </a-table-column>
                </a-table-column-group>

                <a-table-column key="growth" className="align-center text-small text-center">
                    <span slot="title"><strong>Growth</strong></span>
                    <span slot-scope="record">
                         <template v-if="growthCalc(record) <= 0">
                                <strong><a-badge status="error" :text="growthCalc(record) + '%'" /></strong>
                            </template>
                            <template v-else>
                                <strong><a-badge status="success" :text="growthCalc(record) + '%'" /></strong>
                            </template>
                    </span>
                </a-table-column>

                <a-table-column-group class="column-score">
                    <span slot="title">Remidi</span>

                    <a-table-column key="remedy_questions" title="Soal (Q/A/C)" className="align-center text-small text-center">
                        <div slot-scope="record">
                            <template v-if="extractAttempt(record, 1).raw_score >= 65">
                                <h3 title="Question / Answered / Correct">- / - / -</h3>
                            </template>
                            <template v-else>
                                <h3 title="Question / Answered / Correct">
                                    {{ extractAttempt(record, 2).total_questions  }} / {{ extractAttempt(record, 2).total_answered }} / {{ extractAttempt(record, 2).total_correct_answer }}
                                </h3>
                            </template>
                        </div>>
                    </a-table-column>

                    <a-table-column key="remedy_score" title="Score" className="align-center text-small text-center">
                        <span slot-scope="record">
                            <template v-if="extractAttempt(record, 1).raw_score >= 65">
                                <strong><a-badge status="default" text="-" /></strong>
                            </template>
                            <template v-else>
                                <template v-if="extractAttempt(record, 2).raw_score < 65">
                                    <strong><a-badge status="error" :text="extractAttempt(record, 2).raw_score" /></strong>
                                </template>
                                <template v-else>
                                    <strong><a-badge status="success" :text="extractAttempt(record, 2).raw_score" /></strong>
                                </template>
                            </template>
                        </span>
                    </a-table-column>
                </a-table-column-group>
            </a-table>
        </a-card>
    </div>
</template>

<script>
export default {
    props: {
        class_id: {
            type: String,
            required: true
        },
        session: {
            type: String,
            required: true
        },
        previous: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            loading: false,
            processing: false,
            visible: false,
            items: {},
            data: {},
            filters: {
                q: null,
                email: null,
                page: 1
            }
        };
    },
    created() {
        this.filters = _.merge(this.filters, this.$laravel.request);
        this.getItems();
    },
    computed: {
        excel() {
            let excel = []
            let vm = this

            if (this.loading)
                return excel

            this.items.users_scores.forEach(function(r,n) {
                let pretest = vm.extractAttempt(r, 99)
                let exam = vm.extractAttempt(r, 1)
                let remedy = vm.extractAttempt(r, 2)

                excel.push({
                    no: n+1,
                    name: r.name,
                    gender: r.gender,
                    pretest: `${pretest.total_questions} / ${pretest.total_answered} / ${pretest.total_correct_answer}`,
                    pretest_score: pretest.raw_score,
                    exam: `${exam.total_questions} / ${exam.total_answered} / ${exam.total_correct_answer}`,
                    exam_score: exam.raw_score,
                    growth_percentile: vm.growthCalc(r) + '%',
                    remedy: `${remedy.total_questions} / ${remedy.total_answered} / ${remedy.total_correct_answer}`,
                    remedy_score: remedy.raw_score,
                })
            })

            return excel
        },
        activeModule() {
            return this.$laravel.active_module
        },
        itemsSession() {
            return this.items.session != null ? this.items.session : {}
        },
        training_module() {
            return this.$laravel.training_modules.classical
        },
        tableColumns() {
            return this.columns
        },
        classicalVerifyLevel(){
            return this.itemsSession != null ? this.itemsSession.classical_verification_level.toString() : ""
        },
        ispmbk(){
            return this.$laravel.roles[this.activeModule.module.identifier] === 'project-manager'
        }
    },
    methods: {
        tableChanged(pagination) {
            this.filters.page = pagination.current;
            this.pushState(this.filters);
            this.getItems();
        },
        growthCalc(record) {
            let rawPost = parseInt(this.extractAttempt(record, 1).raw_score)
            let rawPre =  parseInt(this.extractAttempt(record, 99).raw_score)
            let rawCalc = rawPost - rawPre
            let divider = rawPre === 1 ? 0 : rawPre

            if (divider === 0)
                return 100

            return Math.round((rawCalc / divider) * 100)
        },
        extractAttempt(record, number)
        {
            let blank = {
                total_questions: 0,
                total_answered: 0,
                total_correct_answer: 0,
                raw_score: 0
            }

            if (record.activities[0].attempts.length < 0) {
                return blank
            }

            let attempt = record.activities[0].attempts.find(_o => _o.attempt_number === number)
            if (typeof attempt === 'undefined') {
                return blank
            }

            return attempt
        },
        getItems() {
            this.loading = true;
            this.$http
                .get(this.routeUri("api.classical-exam.report", {session: this.session}))
                .then(response => (this.items = response.data))
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        download(url) {
            window.open(url, '_blank')
        },
        back() {
            window.location.href = this.routeUri('admin.classical.exam.sessions')
        },
        gender(gender){
            switch(gender){
                case "male":
                    return "Laki-laki"
                case "female":
                    return "Perempuan"
                default:
                    return ""
            }
        }
    },
}
</script>
